<template>
    <div class="driver-info new">
        <ucar-title to="/new-driver-info">{{title}}</ucar-title>
        <ucar-section title="请输入您的身份信息">
            <div class="row row-info">
                <label>姓名</label>
                <dynamic-textarea placeholder="请输入"
                    :only-zh="true"
                    v-model="personalInfo.name"
                    ref="inp"
                    :maxlength="20"></dynamic-textarea>
            </div>
            <div class="row row-info">
                <label>身份证号</label>
                <number-x-keyboard v-model="personalInfo.idCardNo" :maxlength="20" placeholder="请输入"/>
            </div>
        </ucar-section>
        <p class="driver-info-auth" v-if="enableSubmit">点击提交即表示同意<span @click="goAuthorizeProtocol">《个人征信查询授权书》</span></p>
        <div class="footer">
        <button type="button"
                class="btn-submit"
                :class="{'btn-submit-enable': enableSubmit}"
                @click="submit">
            提交
        </button>
        </div>
        <error-dialog v-if="showErrorDialog"
            @close="closeErrorDialog"
            :groups="rejectErrors"></error-dialog>
        <protocol-dialog
            v-if="showProtocolDialog"
            @agree="signNew"
            @close="showProtocolDialog = false"></protocol-dialog>
    </div>
</template>
<script>
import NumberXKeyboard from "../../components/number-x-keyboard"
import DynamicTextarea from '../../components/dynamic-textarea'
import ProtocolDialog from '../../components/protocol-dialog'
import ErrorDialog from '../../components/error-dialog'
import { signNew, submitSimpleDriverInfo } from '../../api'
import { checkFailText } from '../../utils/constants'
import valid from '../../utils/valid-check'
export default {
    components: {
        NumberXKeyboard,
        DynamicTextarea,
        ProtocolDialog,
        ErrorDialog
    },
    data () {
        return {
            showErrorDialog: false,
            rejectErrors: [],
            showProtocolDialog: false,
            personalInfo:{
                enlistId: '',
                serviceCityId: '',
                sourceId: '',
                name: '',
                idCardNo: ''
            }
        }
    },
    methods: {
        closeErrorDialog () {
            this.showErrorDialog = false
            this.rejectErrors = []
        },
        async submit () {
            try {
                // console.log('this.personnalInfo',this.personalInfo)
                const submitRes = await submitSimpleDriverInfo(this.personalInfo)
                // console.log('submitRes',submitRes)
                if (submitRes.checkDriverResult !== 0) {
                const offLine = submitRes.checkDriverResult === -2
                this.$alert({
                    type: 'confirm',
                    dsc: `该身份证号${offLine ? checkFailText.offLine : checkFailText.settledBySubmit}`,
                    okText: offLine ? '我知道了' : '我知道了，下载App',
                    center: true,
                    callback: () => {
                    if (!offLine) {
                        location.assign('https://m.10101111.com/ptdapp/d')
                    }
                    }
                })
                    return
                }
                if (submitRes.checkResult === 1) {
                    this.showProtocolDialog = true
                    return
                }
                // 处理驳回错误信息
                if (submitRes.checkResult === 2) {
                    if (submitRes.idCardCheckList.length > 0) {
                        const group = {
                            title: '身份证',
                            type: 'list',
                            list: []
                        }
                        const list = submitRes.idCardCheckList
                        list.forEach(item => {
                            group.list.push(item)
                        })
                        this.rejectErrors.push(group)
                    }
                    this.showErrorDialog = true
                    return
                }
                if (submitRes.checkResult === 3) {
                    this.changeStatusToReviewInfo()
                    if(submitRes.refuseReason.length!==0){
                        this.setVuexCrimeRejectReason(submitRes.refuseReason)
                    }
                    // console.log('this.vuexCrimeRejectReason???',this.vuexCrimeRejectReason)
                    this.$router.push(`/new-progress-info?id=${this.vuexRecruitId}`)
                }
                // 身份证号已注册
        if (submitRes.checkResult === 6) {
          this.$alert({
            type: 'confirm',
            dsc: `${submitRes.refuseReason}`,
            okText: '我知道了',
            center: true,
            // callback: () => {
            //   if (!offLine) {
            //     location.assign('https://m.10101111.com/ptdapp/d')
            //   }
            // }
          })
          return
        }
        // 当前身份证号已成为神州正式司机
        if (submitRes.checkResult === 7) {
          this.$alert({
            type: 'confirm',
            dsc: `${submitRes.refuseReason}`,
            okText: '我知道了',
            center: true,
            // callback: () => {
            //   if (!offLine) {
            //     location.assign('https://m.10101111.com/ptdapp/d')
            //   }
            // }
          })
          return
        }
                // console.log('submitRes?',submitRes)
            } catch (error) {
                this.$store.dispatch('setVuexCurrentCity', { id: this.vuexCurrentCity.cityId })
                console.warn(error)
            }
            
        },
        routeStore() {
            ucarStorage.setStorage('routeTo','simple-driver-info')
        },
        enableSubmit () {
            const errorInfo = valid.notEmpty(this.personalInfo.name, '真实姓名') && valid.notEmpty(this.personalInfo.idCardNo, '身份证号')
            console.log('errorInfo',errorInfo)
                return errorInfo === ''
        },
        goAuthorizeProtocol () {
            this.$router.push('/authorize-protocol')
        },
        async signNew () {
            this.showProtocolDialog = false
            const res = await signNew({
                enlistId: this.vuexRecruitId
            })
            // console.log('签约res',res)
            if (res.resultCode === 0) {
                if(this.vuexOwnCarJoin === true){
                    this.$router.push('/new-vehicle-info')
                } else{
                    this.$router.push(`/new-progress-info?id=${this.vuexRecruitId}`)
                }
            }
        },
    },
    mounted () {
        this.personalInfo.serviceCityId = this.vuexCurrentCity.cityId
        this.personalInfo.enlistId = this.vuexRecruitId
        // console.log('this.vuexRecruitId',this.vuexRecruitId)
        // console.log('this.vuexCurrentCity',this.vuexCurrentCity)
    },
    created() {
        window.addEventListener('beforeunload', this.routeStore)
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.routeStore)
    },
}

</script>

<style scoped>
>>> .ucar-section-title {
  font-weight: 550;
}
</style>